<template>
	<div class="container" ref="generateReportRef">
		<!-- 背景区域 -->
		<img
			class="collect-bg"
			src="@/assets/annualReport/generate-bg.png"
			alt=""
		/>

		<!-- 报告卡片 -->
		<div class="certificate-card" :class="{ 'animate-in': isVisible }">
			<div class="card-header">
				<div class="card-title">
					库迪咖啡主理人<span>@</span>{{ reportData.memberNickName }}
				</div>
			</div>

			<div class="certification-text">
				您已成功得到库迪咖啡官方认证，特奉称号：
			</div>

			<img class="title-big" :src="titleImgSrc" />

			<div class="title-desc">{{ userInfoConfig.titleDesc }}</div>

			<div class="message-content">
				<div
					v-if="userInfoConfig.participationRate"
					class="radius-box participation-header"
					:class="{ 'animate-in': isVisible }"
				>
					大事件参与度&nbsp;<span>{{ userInfoConfig.participationRate }}%</span>
				</div>
				<div
					v-else
					class="radius-box participation-header text-top-center"
					:class="{ 'animate-in': isVisible }"
				>
					新任主理人正蓄势待发
				</div>

				<div
					class="radius-box participation-data"
					:class="{ 'animate-in': isVisible }"
				>
					{{ userInfoConfig.participationDesc1 }}<br />
					{{ userInfoConfig.participationDesc2 }}
				</div>

				<div
					class="radius-box award-section"
					:class="{ 'animate-in': isVisible }"
				>
					<img class="trophy-icon" src="@/assets/annualReport/trophy.png" />
					<div class="award-info">
						<div class="award-label">特颁奖项：</div>
						<div class="award-name">{{ userInfoConfig.awardName }}</div>
					</div>
				</div>

				<img
					class="character-3d"
					:class="{ 'animate-in': isVisible }"
					:src="characterImgSrc"
				/>
			</div>
		</div>

		<!-- 底部按钮 -->
		<!--  -->
		<div class="bottom-actions" v-if="showButton">
			<div class="btn btn-generate" @click="handleSaveImage">保存报告</div>
			<div
				class="btn btn-share"
				v-if="!reportData.hasClaimedCoupon"
				@click="handleShare"
			>
				分享领券
			</div>
			<div class="btn btn-share" v-else @click="handleShare">分享好友</div>
		</div>

		<!-- 隐藏的绘制区域 -->
		<div class="container canvas-fixed" ref="certificateCard">
			<!-- 背景区域 -->
			<img
				class="collect-bg"
				src="@/assets/annualReport/generate-bg.png"
				alt=""
			/>

			<!-- 报告卡片 -->
			<div class="certificate-card">
				<!-- 顶部标题 -->
				<div class="card-header">
					<div class="card-title">
						库迪咖啡主理人<span>@</span>{{ reportData.memberNickName }}
					</div>
				</div>

				<!-- 认证文案 -->
				<div class="certification-text">
					您已成功得到库迪咖啡官方认证，特奉称号：
				</div>

				<!-- 称号大字 -->
				<img class="title-big" :src="titleImgSrc" />

				<!-- 称号描述 -->
				<div class="title-desc">{{ userInfoConfig.titleDesc }}</div>

				<!-- 底部描述-按序排列 -->
				<div class="message-content">
					<!-- 参与度标题 -->
					<div
						v-if="userInfoConfig.participationRate"
						class="radius-box participation-header"
					>
						大事件参与度&nbsp;<span
							>{{ userInfoConfig.participationRate }}%</span
						>
					</div>
					<div v-else class="radius-box participation-header text-top-center">
						新任主理人正蓄势待发
					</div>

					<!-- 参与度数据 -->
					<div class="radius-box participation-data">
						{{ userInfoConfig.participationDesc1 }}<br />
						{{ userInfoConfig.participationDesc2 }}
					</div>

					<!-- 特颁奖项 -->
					<div class="radius-box award-section">
						<!-- 奖杯图标 -->
						<img class="trophy-icon" src="@/assets/annualReport/trophy.png" />
						<div class="award-info">
							<div class="award-label">特颁奖项：</div>
							<div class="award-name">{{ userInfoConfig.awardName }}</div>
						</div>
					</div>

					<!-- 3D角色图片 -->
					<img class="character-3d" :src="characterImgSrc" />
				</div>
			</div>
			<!-- 二维码画布 -->
			<div
				class="qrcode-wrapper"
				@click="handleSaveImage"
				v-if="configData.qrcode"
			>
				<canvas ref="qrcodeCanvas" class="qrcode-canvas"></canvas>
				<div class="qrcode-message">
					扫一扫查看你的<br /><span>2025</span>主理人报告
				</div>
				<!-- 水印 -->
				<div class="watermark">
					<img src="@/assets/annualReport/watermark.png" alt="" />
				</div>
			</div>
		</div>

		<div v-if="show" class="poster-modal">
			<div class="poster-image">
				<img
					@click.stop="jumpConfig"
					class="coupon"
					:src="matchedConfig.picUrl"
				/>
				<!-- :src="matchedConfig.picUrl" -->
				<img
					@click.stop="jumpConfig"
					class="button"
					:src="matchedConfig.btnUrl"
				/>
				<!-- :src="matchedConfig.picUrl" -->

				<img
					@click="show = false"
					src="@/assets/annualReport/close.svg"
					class="close"
				/>
			</div>
		</div>
	</div>
</template>

<script>
	import html2canvas from "html2canvas";
	import QRCode from "qrcode";

	import { marketingReceiveRewardH5 } from "@/api";

	export default {
		name: "GenerateReport",
		props: {
			active: {
				type: Boolean,
				default: false,
			},
			reportData: {
				type: Object,
				default: () => ({}),
			},
			configData: {
				type: Object,
				default: () => ({}),
			},
		},
		data() {
			return {
				isSharing: false,
				isGenerating: false,
				imageDataUrl: "",
				blackBox: "",
				show: false,
				// 动态配置 - 根据后端数据设置
				userInfoConfig: {
					// 称号图片文件名 (不含路径)
					titleImg: "cxwk.png",
					// 称号描述
					titleDesc: "一入库门深似海,就此开启全新大陆",
					// 参与度百分比
					participationRate: 10,
					// 参与度描述
					participationDesc1: "您的每次闪现,",
					participationDesc2: "都是库迪的彩蛋",
					// 奖项名称
					awardName: "年度新锐探索奖",
					// 小人图片文件名 (不含路径)
					characterImg: "cxwk-xr.png",
				},
				matchedConfig: {},
				showButton: true,
				isVisible: false,
			};
		},
		computed: {
			// 动态获取称号图片路径
			titleImgSrc() {
				return require(`@/assets/annualReport/${this.userInfoConfig.titleImg}`);
			},
			// 动态获取小人图片路径
			characterImgSrc() {
				return require(`@/assets/annualReport/${this.userInfoConfig.characterImg}`);
			},
		},
		async mounted() {
			// this.init();
			this.initObserver();
			this.getAppVersion();
			window.onShareCallback = this.onShareCallback;
		},

		methods: {
			getAppVersion() {
				try {
					let version = navigator.userAgent.split("/")[1];
					if (version >= 263) {
						this.showButton = true;
					} else {
						this.showButton = false;
					}
				} catch (e) {
					console.warn("获取App版本失败", e);
				}
			},
			initObserver() {
				// 进入页面时，给 body 加上锁
				document.body.classList.add("lock-scroll");
				const vm = this;

				vm.observer = new IntersectionObserver(
					function (entries) {
						const entry = entries[0];

						if (entry.isIntersecting) {
							console.log("海报 进入视野");
							vm.isVisible = true;
						} else {
							console.log("海报 离开视野");
							vm.isVisible = false;
						}
					},
					{ threshold: 0.1 }
				);
				if (vm.$refs.generateReportRef) {
					vm.observer.observe(vm.$refs.generateReportRef);
				}
			},
			async init() {
				// 根据注册天数设置用户信息配置
				this.setUserInfoByCreateDay();

				if (this.configData.qrcode) {
					// 生成二维码
					await this.generateQRCode();
				}
				await this.handleGenerateReport();
			},
			/**
			 * 根据注册天数设置用户信息配置
			 * 参与度设置文案
			 */
			setUserInfoByCreateDay() {
				const createDay = this.reportData.createDay || 0;
				const participationRate = Math.floor(
					(this.reportData.participationRate || 0) * 100
				);

				if (createDay < 100) {
					// 年度新锐探索奖（注册时长 < 100天）
					this.userInfoConfig.titleImg = "cxwk.png";
					this.userInfoConfig.titleDesc = "一入库门深似海，就此开启全新大陆";
					this.userInfoConfig.awardName = "年度新锐探索奖";
					this.userInfoConfig.characterImg = "cxwk-xr.png";
				} else if (createDay >= 100 && createDay < 400) {
					// 年度潮流引领奖（100天 <= 注册时长 < 400天）
					this.userInfoConfig.titleImg = "kjzy.png";
					this.userInfoConfig.titleDesc = "从“尝鲜”到“熟知”，默契已无需多言";
					this.userInfoConfig.awardName = "一生挚爱大咖奖";
					this.userInfoConfig.characterImg = "kjzy-xr.png";
				} else if (createDay >= 400 && createDay < 800) {
					// 年度美学创造奖（400天 <= 注册时长 < 800天）
					this.userInfoConfig.titleImg = "ysgr.png";
					this.userInfoConfig.titleDesc = "千杯风味过喉，心中已成谱系";
					this.userInfoConfig.awardName = "德艺双馨老咖奖";
					this.userInfoConfig.characterImg = "ysgr-xr.png";
				} else {
					// 年度终身成就奖（注册时长 >= 800天）
					this.userInfoConfig.titleImg = "rkhy.png";
					this.userInfoConfig.titleDesc = "时光沉淀，终成古希腊掌管库迪的神";
					this.userInfoConfig.awardName = "终身成就幻神奖";
					this.userInfoConfig.characterImg = "rkhy-xr.png";
				}

				if (participationRate === 0) {
					this.userInfoConfig.participationDesc1 = '首个据点，'
					this.userInfoConfig.participationDesc2 = '即将点亮...'
				} else if (participationRate < 10) {
					this.userInfoConfig.participationDesc1 = '每次闪现都是'
					this.userInfoConfig.participationDesc2 = '品牌惊喜彩蛋'
				} else if (participationRate >= 10 && participationRate < 30) {
					this.userInfoConfig.participationDesc1 = '用稳定参与度'
					this.userInfoConfig.participationDesc2 = '守护品牌调性'
				} else if (participationRate >= 30 && participationRate < 60) {
					this.userInfoConfig.participationDesc1 = '存在本身是对'
					this.userInfoConfig.participationDesc2 = '团队最大支持'
				} else {
					this.userInfoConfig.participationDesc1 = '用实际行动践行'
					this.userInfoConfig.participationDesc2 = '“股权绑定”'
				}

				this.userInfoConfig.participationRate = participationRate;
			},
			/**
			 * 生成二维码
			 */
			async generateQRCode() {
				try {
					const canvas = this.$refs.qrcodeCanvas;
					if (!canvas) return;

					await QRCode.toCanvas(canvas, this.configData.qrcode, {
						width: 80,
						margin: 3,
						errorCorrectionLevel: "H",
						color: {
							dark: "#000000",
							light: "#ffffff",
						},
					});
				} catch (error) {
					console.error("生成二维码失败:", error);
				}
			},
			/**
			 * 生成报告图片
			 */
			async handleGenerateReport() {
				try {
					const cardElement = this.$refs.certificateCard;
					if (!cardElement) {
						throw new Error("未找到证书卡片元素");
					}

					// 使用 html2canvas 将 DOM 转为 canvas
					const canvas = await html2canvas(cardElement, {
						backgroundColor: "#ffffff",
						scale: 2, // 提高清晰度
						useCORS: true, // 允许跨域图片
						logging: false,
					});

					// 将 canvas 转为图片
					this.imageDataUrl = canvas.toDataURL("image/png");
					// console.log("生成的图片数据URL:", this.imageDataUrl);
				} catch (error) {
					console.error("生成报告失败:", error);
				}
			},
			/**
			 * 保存图片到相册
			 */
			async handleSaveImage() {
				if (this.isGenerating) return;
				this.isGenerating = true;
				try {
					let data = JSON.stringify({
						base64Info: this.imageDataUrl,
					});
				 	await savePosterImage.postMessage(data);
				} catch (e) {
					console.error("保存图片失败", e);
				} finally {
					setTimeout(() => {
						this.isGenerating = false;
					}, 500);
				}
			},
			/**
			 * 分享
			 */
			async handleShare() {
				if (this.isSharing) return;
			    this.$sensors.track('annual_report_share_click')
				this.isSharing = true;
				try {
					// 分享逻辑
					let data = JSON.stringify({
						shareQrCodeUrl: "",
						sharePosterList: [
							{
								base64Info: this.imageDataUrl,
							},
						],
					});
					await sharePoster.postMessage(data);
				} catch (e) {
					console.error(e);
				} finally {
					setTimeout(() => {
						this.isSharing = false;
					}, 500);
				}
			},
			/**
			 * 分享海报回调逻辑
			 *
			 * 取消：onCancel
			 * 保存：saveToImageGallery
			 * 分享到朋友圈：shareToTimeLine
			 * 分享给好友：shareToSession
			 * */
			onShareCallback(data) {
				console.log("分享回调数据:", data);
				// 未领券 或 活动限流 ————> 领券
				if (!this.reportData.hasClaimedCoupon || this.reportData.isLimited) {
					// 处理分享结果
					if (["shareToTimeLine", "shareToSession"].includes(data)) {
						console.log("分享成功");
						this.handleClaimCoupon();
					}
				}
			},

			// 领券操作
			async handleClaimCoupon() {
				try {
					let res = await window?._fmOpt?.getinfo();
					if (res) {
						this.blackBox = res;
						console.log(res);
					}
				} catch (e) {
					console.warn("获取黑盒失败", e);
					if (window.blackBox) {
						this.blackBox = window.blackBox;
					}
				}
				// 领券逻辑
				let data = {
					activityNo: this.configData.activityNo,
					comeFrom: 4,
					blackBox: this.blackBox,
				};

				let res = await marketingReceiveRewardH5(data);
				console.log(res);

				if (res.busCode === "1") {
					if(res.data.status !== 1){
						this.$emit("claimedCoupon");
						let path = { path: `${this.$config.env.VUE_APP_DOWNLOAD}/#/ticket?comefrom=4&abiteol_tylq=1&auth=1&activityNo=${this.configData.activityNo}&a=3` };
						CottiNavigation.postMessage(JSON.stringify(path));
						return
					}
					// 领取成功 - 展示跳转弹窗
					let tempNoList =
						res.data.prizeCouponResultList.map((item) => item.templateNo) || [];

					// 根据 tempNoList 和 activityPopup 比对,找到完全匹配的配置
					let matchedConfig = null;
					if (
						this.configData.activityPopup &&
						this.configData.activityPopup.length > 0
					) {
						matchedConfig = this.configData.activityPopup.find((config) => {
							// 检查 config.tempNo 与 tempNoList 是否完全一致
							if (
								!config.tempNo ||
								config.tempNo.length !== tempNoList.length
							) {
								return false;
							}
							// 排序后比较两个数组是否完全相同
							const sortedConfigTempNo = [...config.tempNo].sort();
							const sortedTempNoList = [...tempNoList].sort();
							return sortedConfigTempNo.every(
								(no, index) => no === sortedTempNoList[index]
							);
						});
					}

					console.log("匹配的配置:", matchedConfig);
				this.$sensors.track('annual_report_coupon_result', {
					result: 'success'
					})
					// TODO: 使用 matchedConfig 进行后续操作
					if (matchedConfig) {
						// 有匹配的配置,使用 matchedConfig.picUrl 和 matchedConfig.redirectPath
						this.show = true;
						this.matchedConfig = matchedConfig;
						this.$sensors.track('annual_report_popup_view', {
            tempNoList: tempNoList.join(',')
          })
					}
	
					this.$emit("claimedCoupon");
				} else {
					// 领取失败-跳转通用领券页
					try {
						 this.$sensors.track('annual_report_coupon_result', {
							result: 'failure'
						})
						let path = { path: `${this.$config.env.VUE_APP_DOWNLOAD}/#/ticket?comefrom=4&abiteol_tylq=1&auth=1&activityNo=${this.configData.activityNo}&a=3` };

						CottiNavigation.postMessage(JSON.stringify(path));
					} catch (e) {
						console.warn(e);
					}
				}
			},
			jumpConfig() {
				if (this.matchedConfig && this.matchedConfig.redirectPath) {
					try {
						let path = { path: this.matchedConfig.redirectPath };
						CottiNavigation.postMessage(JSON.stringify(path));
					} catch (e) {
						console.warn(e);
					}
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		position: relative;
		height: 100vh;
		width: 100%;
		display: flex;
		// justify-content: center;
		align-items: center;
		flex-direction: column;

		.collect-bg {
			position: absolute;
			width: 100%;
			// height: 100vh;
			top: 0;
			left: 0;
			z-index: -1;
		}

		.certificate-card {
			// opacity: 0.2;
			// margin-left: 200px;
			position: relative;
			width: auto;
			height: 974px;
			margin-top: 300px;
			opacity: 0;
			&.animate-in {
				animation: rollInTopLeft 1s ease-out forwards;
			}
			background: url("../../../assets/annualReport/generate-content.png")
				no-repeat center;
			background-size: cover;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;

			// 顶部标题
			.card-header {
				.card-title {
					width: 539px;
					margin: 80px 109px 0;
					font-weight: 600;
					font-size: 29px;
					color: #5b2a15;
					text-align: left;
					font-style: normal;
					border-bottom: 1px solid #5b2a15;
					box-sizing: border-box;
					padding-bottom: 26px;

					// 文案超出一行打点
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					> span {
						font-family: "MontserratRoman-Medium";
						font-size: 36px;
					}
				}
			}

			// 认证文案
			.certification-text {
				font-weight: 600;
				font-size: 23px;
				color: #5b2a15;
				text-align: center;
				margin: 28px auto 22px;
			}

			// 称号大字
			.title-big {
				width: 647px;
				height: auto;
				margin: 0 auto;
			}

			// 按钮图片
			.title-desc {
				margin: 26px auto 0;
				width: 466px;
				height: 51px;
				background: #ffa300;
				border-radius: 25px 25px 25px 25px;
				line-height: 51px;

				font-weight: 600;
				font-size: 24px;
				color: #ffffff;
				text-align: center;
			}
			// 底部描述
			.message-content {
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				width: 647px;
				height: 442px;
				margin: 0 auto;
				padding-left: 52px;
				box-sizing: border-box;
				position: relative;

				.radius-box {
					width: 369px;
					// border-radius: 41px;
					background: rgba($color: #ffcfd3, $alpha: 0.4);
					opacity: 0;
					&.animate-in {
						animation: fadeInUp 0.5s ease-out forwards;
					}
				}
				.participation-header {
					margin-top: 44px;
					padding: 20px 0 28px 28px;
					font-weight: 600;
					font-size: 24px;
					color: #000000;
					line-height: 1;
					box-sizing: border-box;
					// letter-spacing: 2px;
					border-radius: 48px;
					&.animate-in {
						animation-delay: 0.5s;
					}
					> span {
						font-family: "MontserratRoman-Bold";
						font-weight: bold;
						font-size: 48px;
						color: #f03a2d;
						display: inline-block;
					}
				}
				.text-top-center{
					padding: 24px 0 24px 28px;
				}
				.participation-data {
					border-radius: 54px;
					margin-top: 24px;
					height: 108px;
					font-weight: 600;
					font-size: 24px;
					color: #000000;
					line-height: 36px;
					text-align: left;
					display: flex;
					flex-direction: column;
					justify-content: center;
					box-sizing: border-box;
					padding-left: 28px;
					&.animate-in {
						animation-delay: 0.7s;
					}
				}
				.award-section {
					margin-top: 24px;
					position: relative;
					display: flex;
					height: 112px;
					border-radius: 56px;
					&.animate-in {
						animation-delay: 0.9s;
					}

					.trophy-icon {
						width: 84px;
						height: 125px;
						position: absolute;
						bottom: 0;
					}
					.award-info {
						margin-left: 86px;
						display: flex;
						flex-direction: column;
						justify-content: center;

						font-weight: 600;
						font-size: 24px;
						color: #000000;
						text-align: left;
						// padding: 24px 0 28px;
						line-height: 36px;

						.award-label {
							// margin-bottom: 5px;
						}
						.award-name {
							color: #f03a2d;
							font-weight: bold;
						}
					}
				}
				.character-3d {
					position: absolute;
					top: 0px;
					right: 0px;
					width: 647px;
					height: 442px;
					opacity: 0;
					&.animate-in {
						animation: rollInBottomRight 1s ease-out forwards;
					}
				}
			}
		}
		.bottom-actions {
			display: flex;
			gap: 46px;
			.btn {
				width: 305px;
				height: 93px;
				line-height: 93px;
				text-align: center;

				font-weight: bold;
				font-size: 33px;
				border-radius: 43px;
			}
			.btn-generate {
				background: url("../../../assets/annualReport/button-left.png")
					no-repeat center;
				background-size: 100% 100%;
				color: #000000;
				box-shadow: -14px 14px 50px rgba(160, 0, 26, 0.55);
			}
			.btn-share {
				background: url("../../../assets/annualReport/button-right.png")
					no-repeat center;
				background-size: 100% 100%;
				color: #ffffff;
				box-shadow: -14px 14px 50px rgba(160, 0, 26, 0.55);
			}
		}
		.qrcode-wrapper {
			display: flex;
			width: 100%;
			padding-left: 57px;
			box-sizing: border-box;
			align-items: flex-start;
			gap: 24px;
			margin-top: -4px;
			.qrcode-canvas {
				border-radius: 10px;
			}
			.qrcode-message {
				// width: 186px;
				// height: 59px;
				margin-top: 29px;
				font-weight: 600;
				font-size: 24px;
				color: #eeeded;
				line-height: 36px;
				text-align: left;
				// letter-spacing: 1px;

				span {
					font-family: "MontserratRoman-SemiBold";
					font-size: 28px;
				}
			}
		}
		.watermark {
			margin: auto 54px 0px auto;
			> img {
				width: 158px;
				height: auto;
			}
		}
	}
	.canvas-fixed {
		position: absolute;
		width: 750px;
		height: 1268px;
		left: -10000px;
		.certificate-card {
			margin-top: 83px;
			animation: none !important;
			opacity: 1 !important;
			.character-3d {
				animation: none !important;
				opacity: 1 !important;
			}
			.radius-box {
				animation: none !important;
				opacity: 1 !important;
			}
		}
	}
	.poster-modal {
		width: 100%;
		height: 100vh;
		position: absolute;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.7);
	}
	.poster-image {
		width: 100%;
		height: auto;
		position: absolute;
		top: 40%;
		left: 50%;
		transform: translate(-50%, -50%);
		display: flex;
		flex-direction: column;
		align-items: center;
		.coupon {
			width: 100%;
			height: auto;
		}
		.button {
			width: 286px;
			height: auto;
			position: absolute;
			top: 520px;
		}
		.close {
			width: 48px;
			height: 48px;
		}
	}

	@keyframes rollInTopLeft {
		0% {
			opacity: 0;
			transform: translate3d(-100%, -100%, 0) rotate3d(0, 0, 1, -120deg);
		}
		100% {
			opacity: 1;
			transform: none;
		}
	}

	@keyframes rollInBottomRight {
		0% {
			opacity: 0;
			transform: translateX(200%);
		}
		100% {
			opacity: 1;
			transform: none;

		}
	}

	@keyframes fadeInUp {
		from {
			opacity: 0;
			transform: translate3d(0, 20px, 0);
		}
		to {
			opacity: 1;
			transform: none;
		}
	}
</style>
